import { CollectionModelFieldHeight } from '@ikegps/core-shared';
import { IkeCalcFieldJoin } from './field.join.ikecalc';

const WIRE_PHASE_HEIGHTS = ['phaseAHeight', 'phaseBHeight', 'phaseCHeight'];

export class PoleForemanWirePhaseHeightFieldJoin extends IkeCalcFieldJoin {
	type = 'PoleForemanWirePhaseHeightJoin';

	static accepts(field: CollectionModelFieldHeight) {
		return WIRE_PHASE_HEIGHTS.indexOf(field.schema.id) > -1;
	}

	constructor(field: CollectionModelFieldHeight) {
		super(field);
	}

	joins(other: PoleForemanWirePhaseHeightFieldJoin): boolean {
		const joinableHeight = this.getFieldValue(this.wire, this.field.schema.id);
		if (joinableHeight != null) {
			return false;
		}

		const framingType = this.getFieldValue(this.wire, 'framingType');
		if (this.isDeadEnd(framingType)) {
			return false;
		}

		if (!other.wire.hasField(this.field.schema.id) || this.getFieldValue(other.wire, this.field.schema.id) != null) {
			return false;
		}

		return (
			this.spansOpposing(this.span, other.span) &&
			this.fieldsEqual(this.wire, other.wire, 'framingType') &&
			this.fieldsEqual(this.wire, other.wire, 'wireSize') &&
			this.fieldsEqual(this.wire, other.wire, 'wireQuantity')
		);
	}
}
